import { CheckoutParamEnum } from 'components/views/pages/Checkout/types';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import dayjs from 'dayjs';
import { dateFormatServer, handleAddDay } from '@alluradirect/react';
import { useContactParams } from 'components/views/pages/contact/useContactParams';

dayjs.extend(customParseFormat);
interface Param {
  name: CheckoutParamEnum;
  value: string | number;
}

export const useContactFixInvalidParams = () => {
  const router = useRouter();

  const { adults, pets, pChildren, infants, startDate, endDate } = useContactParams();

  useEffect(() => {
    if (!router.isReady) return;

    const paramsToFix: Param[] = [];

    // to support no guests by default
    if (adults !== undefined || pChildren !== undefined || infants !== undefined) {
      if (!adults || (adults && Number(adults) <= 0)) {
        paramsToFix.push({
          name: CheckoutParamEnum.adults,
          value: 1,
        });
      }
  
      if (!pChildren || (pChildren && Number(pChildren) < 0)) {
        paramsToFix.push({
          name: CheckoutParamEnum.children,
          value: 0,
        });
      }
  
      if (!infants || (infants && Number(infants) < 0)) {
        paramsToFix.push({
          name: CheckoutParamEnum.infants,
          value: 0,
        });
      }
    }

    if (!pets || (pets && Number(pets) < 0)) {
      paramsToFix.push({
        name: CheckoutParamEnum.pets,
        value: 0,
      });
    }

    const isStartDateValid = dayjs(startDate, 'YYYY-MM-DD', true).isValid();
    const isEndDateValid = dayjs(endDate, 'YYYY-MM-DD', true).isValid();
    const today = dateFormatServer(dayjs());

    if (startDate && !isStartDateValid) {
      paramsToFix.push({
        name: CheckoutParamEnum.startDate,
        value: '',
      });
    }

    if (endDate && !isEndDateValid) {
      paramsToFix.push({
        name: CheckoutParamEnum.endDate,
        value: '',
      });
    }

    if (startDate && endDate && !isEndDateValid && isStartDateValid) {
      const nextValidEndDate = dateFormatServer(handleAddDay(startDate ?? today));

      paramsToFix.push({
        name: CheckoutParamEnum.endDate,
        value: nextValidEndDate,
      });
    }

    if (paramsToFix.length) {
      router.replace({
        pathname: router.pathname,
        query: {
          ...router.query,
          ...paramsToFix.reduce((curr, next) => {
            const val = {
              ...curr,
              [next.name]: next.value,
            };
            return val;
          }, {}),
        },
      });
    }
  }, [adults, endDate, pChildren, pets, router, startDate, infants]);
};
